import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import { Utils } from '../../Utils';
import './PopupRateApp.css';

class PopupRateApp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  show() {
    this.setState({ show: true });
  }

  // bezáráskor (X gomb, vagy a hardveres vissza gomb, ami közvetlenül ezt hívja) - ha nem
  // értékelt még a felhasználó, beállítjuk a 14 napos cooldown-t, mielőtt újra megjelenne
  hide() {
    if (localStorage.getItem('rate_app_rated') !== '1') {
      Utils.postponeRateAppPopup();
    }

    this.setState({ show: false });
  }

  handleRateClick = async () => {
    await Utils.openStoreForRating();
    this.hide();
  };

  render() {
    if (!this.state.show) return '';

    return (
      <div className="popup_rate_app">
        <div className="popup_rate_app_card">
          <ReactSVG className="close" src="assets/images/close.svg" onClick={() => this.hide()} />
          <div className="icon"><ReactSVG src="assets/images/rate_stars.svg" /></div>
          <h2>{i18n.t('rateAppTitle')}</h2>
          <p>{i18n.t('rateAppText')}</p>
          <button className="button" onClick={this.handleRateClick}>{i18n.t('rateAppRateButton')}</button>
        </div>
      </div>
    );
  }
}

export default PopupRateApp;
